import React, { useState, useContext, useEffect, useRef } from 'react';

import { Badge, Button, Card, CardContent, IconButton, Input, Popover, Typography } from '@mui/material';
import { IoMdCloseCircleOutline } from "react-icons/io";
import moment from 'moment';
import { AppContext } from '../../../../AppContext';
import ApiRequestService from '../../../../components/ApiRequestService';
import { toast } from 'react-toastify';
import { FaCartShopping } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa6";
import { BeatLoader } from 'react-spinners';
import { GoChecklist } from "react-icons/go";
import { TbChecklist } from "react-icons/tb";
import { FaCheckCircle } from "react-icons/fa";
import { IoIosCloseCircle } from "react-icons/io";


const SFPracticeSetCart = ({ selectedCategories, handleRemoveCategory, handleClearCart, handleRoute, onAddActivityLog, onSavePracticeSet }) => {

    const anchorRef = useRef(null);
    const [name, setName] = useState(`Practice Set - ${moment().format('MM/DD/YYYY hh:mm:ss a')}`);
    const [anchorEl, setAnchorEl] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const appContext = useContext(AppContext);
    const [isSaved, setIsSaved] = useState(false);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    useEffect(() => {
        if (selectedCategories && selectedCategories.length) {
            setAnchorEl(anchorRef.current);
        }
    }, [selectedCategories])

    useEffect(() => {
        setIsSaved(false);
    }, []);

    useEffect(() => {
        if (anchorEl) {
            setName(`Practice Set - ${moment().format('MM/DD/YYYY hh:mm:ss a')}`);
        }
    }, [anchorEl])

    const handleClose = () => {
        setAnchorEl(null);
        setIsSaved(false);
    };

    const onCreatePracticeSet = (isSaveOnly) => {
        let quizDetails = [];
        let quizCategoryMasertyCountMap = {}
        let quizCategoryIsRequiredMap = {}
        let quizCategoryPositionMap = {}

        selectedCategories?.forEach((selCat, index) => {
            let catKey = `${selCat.subjectID}_${selCat.topicID}_${selCat.categoryID}`
            let subCatKey = `${catKey}_${selCat.subcategoryID}`
            quizDetails.push({
                "subject_id": selCat.subjectID,
                "topic_id": selCat.topicID,
                "category_id": selCat.categoryID,
                "subcategory_id": selCat.subcategoryID,
                "index": subCatKey,
                "order": index + 1,
                "question_count": 10, // TODO
                "subcategory_name": selCat.subCategoryName,
                "category_name": selCat.name,
                "randomize_questions": selCat.randomize_questions,
                "random_subcategory_order": 1,
                "subcategory_weight": 1,
                "non_graded": 0,
                "category_mastery_count": 3, // set 3 as a default mastery count | selCat.masteryCount,
                "category_is_required": 1,
                "category_at_last": 0,
                "category_at_begining": 0
            })
            quizCategoryMasertyCountMap[catKey] = 3, // set 3 as a default mastery count | selCat.masteryCount,
                quizCategoryIsRequiredMap[catKey] = 1
            quizCategoryPositionMap[catKey] = {
                "category_at_last": 0,
                "category_at_begining": 0,
            }
        })

        let quizCategoryMasertyCountMapStr = JSON.stringify(quizCategoryMasertyCountMap)
        let quizCategoryIsRequiredMapStr = JSON.stringify(quizCategoryIsRequiredMap)
        let quizCategoryPositionMapStr = JSON.stringify(quizCategoryPositionMap)

        const startDate = moment().subtract(1, 'days');
        const endDate = moment().add(6, 'months');

        const { selectedCourse } = appContext;

        console.debug("selectedCourse>>>", selectedCourse)

        let payload = {
            quiz_name: name,
            start_date: startDate.format('DD/MM/YYYY'),
            start_time: "00:00",
            end_date: endDate.format('DD/MM/YYYY'),
            end_time: "23:59",
            quiz_type: 0,
            mastery_condition: 3,
            mastery_units: selectedCategories.length,
            maximum_attempted: 2,
            semester_id: 0,
            course_id: -1, //selectedCourse && selectedCourse.course_id ? selectedCourse.course_id : -1, // -1 or null
            section_Id: -1, // -1 or null
            quiz_details: quizDetails,
            quiz_id: 0,
            testTimerEnabled: 0,
            fullScoreIfAttempted: 0,
            fixedAbsoluteTimeEnabled: 0,
            randomize_categories: 1,
            sections_list: [],
            splash_screen: <p>{name}</p>,
            alt_splash_screen: "",
            NoCQC: 1,
            lockoutN: 20,
            enableSurvey: false,
            category_number_of_questions: '{}',
            category_mastery_count: quizCategoryMasertyCountMapStr,
            category_nocqc: quizCategoryIsRequiredMapStr, // category_nocqc had key and value as quizCategoryIsRequiredMapStr
            random_subcategory_order: quizCategoryIsRequiredMapStr, // random_subcategory_order had key and value as quizCategoryIsRequiredMapStr
            category_is_required: quizCategoryIsRequiredMapStr,
            category_position: quizCategoryPositionMapStr,
            free_choice_count: 0,
            subsection_id: 0,
            enable_subsection: false,
            is_nongraded: 1,
            allow_practice: true
        }

        // console.debug("payload>>>>", payload, isSaveOnly, selectedCategories, appContext)
        setLoading1(isSaveOnly);
        setLoading2(!isSaveOnly);
        let responsePromise = ApiRequestService({
            method: "post",
            url: "/addQuiz",
            data: payload,
        });

        responsePromise.then(res => {
            console.log("res<>??", res.data.data)
            if (res && res.data && res.data.data) {

                setName("");

                let assignment = res.data.data;

                let logPayload = {
                    toNomenclatureID: 0, // clicked
                    quizID: assignment ? assignment.quizID : 0,
                    subjectID: 0,
                    topicID: 0,
                    categoryID: 0,
                    activityTypeID: isSaveOnly ? 20 : 24, // "Save Practice Set" : "Begin Practice Set" activity in p&p page
                };
                if (onAddActivityLog) {
                    onAddActivityLog(logPayload);
                }

                if (appContext && appContext.handleClearCart) {
                    appContext.handleClearCart();
                }
                console.debug("isSaveOnly>>>", isSaveOnly)
                if (isSaveOnly) {
                    setIsSaved(true);
                    if (onSavePracticeSet) {
                        onSavePracticeSet(res.data.data);
                    }
                } else {
                    setIsSaved(false);
                    setAnchorEl(null);
                    handleTakeQuizURL(assignment);
                }
            }
        }).finally(() => {
            setLoading1(false);
            setLoading2(false);
        })

    }

    const handleTakeQuizURL = (assignment) => {

        const { selectedCourse } = appContext;

        let url = `/takequiz?quiz_id=${assignment.quizID || assignment.quiz_id}&course_id=${assignment.courseID || assignment.course_id}&section_id=${assignment.sectionID || assignment.section_id}&quiz_name=${assignment.quizName || assignment.quiz_name}&quiz_type=${assignment.quizType || assignment.quiz_type}&course_name=${selectedCourse?.course_name}`

        handleRoute(url);
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (

        <div className='sf-cart' style={{
            display: selectedCategories?.length || isSaved ? '' : 'none'
        }}>
            <Badge badgeContent={selectedCategories?.length} color='primary'>
                <div className='sf-cart-icon-btn' aria-describedby={"cart-popover"}
                    ref={anchorRef}
                    style={{
                        background: selectedCategories?.length ? '' : 'gray'
                    }}
                    onClick={handleClick}
                >
                    <TbChecklist
                        color='#fff'
                        fontSize={28} />
                </div>
            </Badge>

            <Popover
                id={id}
                open={open && selectedCategories?.length || isSaved}
                // open={selectedCategories?.length ? true : false}
                anchorEl={anchorEl}
                // onClose={handleClose}
                style={{
                    overflow: 'auto',
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                disableScrollLock={true}
                disablePortal
                hideBackdrop
                sx={{
                    pointerEvents: 'none',
                    '& .MuiPaper-root': { pointerEvents: 'auto' },
                }}
            >
                <Card style={{
                    width: '320px',
                    // minHeight: '350px',
                    // height: 'auto',
                    height: 'auto',
                    maxHeight: '100%',
                    overflow: 'auto'
                }} className='py-2 pt-3'>

                    {/* {isSaved ? */}
                        <div className='d-flex w-100 justify-content-between align-items-center px-4 mb-3'>
                            <div className='fontClass-16 font-weight-bold'>Practice Set</div>
                            <div>
                                <IconButton onClick={handleClose}>
                                    <IoIosCloseCircle />
                                </IconButton>
                            </div>
                        </div>
                        {/* : null} */}

                    {isSaved ? <div className='h-100 w-100 px-4 py-5 text-center'>
                        <FaCheckCircle color='#80C75B' fontSize={32} />
                        <Typography fontSize={16} fontWeight={600} className='mt-2'>
                            Created your practice set.
                        </Typography>
                        <Typography fontSize={14} fontWeight={500} className='mt-3'>
                            You can view your set in "My Practice Sets" tab
                        </Typography>
                    </div> :
                        <div className='h-100 w-100'>
                            <CardContent className='px-4 py-0' >
                                <div className='font-weight-bold d-flex justify-content-between align-items-center'>
                                    <div>Selected Categories:</div>
                                    <div>
                                        {/*  <IconButton onClick={handleClose}>
                                            <IoIosCloseCircle />
                                        </IconButton> */}
                                    </div>
                                </div>
                                {selectedCategories && selectedCategories.length ? selectedCategories.map((cat, index) => {
                                    return (
                                        <div className='d-flex justify-content-between align-items-center mt-3' key={index}>
                                            <div className='d-flex justify-content-start align-items-center' style={{
                                                gap: '1rem'
                                            }}>
                                                <div style={{ width: '20px', height: '20px' }}>
                                                    <FaCheck fontSize={18} color='#55853D' />
                                                </div>
                                                <Typography fontSize={14}>
                                                    {cat.name}
                                                </Typography>
                                            </div>
                                            <div>
                                                <IconButton onClick={() => {
                                                    if (loading1 || loading2) return;
                                                    if (selectedCategories.length === 1) {
                                                        setAnchorEl(null);
                                                    }
                                                    handleRemoveCategory(cat);
                                                }}>
                                                    <IoMdCloseCircleOutline fontSize={22} color='#bb0000' />
                                                </IconButton>
                                            </div>
                                        </div>
                                    )
                                })
                                    : null}
                            </CardContent>
                            <div className='text-center pt-3 px-4'>
                                <Input
                                    type='text'
                                    className='w-100'
                                    id="name"
                                    value={name}
                                    disabled={loading1 || loading2}
                                    // inputProps={{ min: 0, style: { textAlign: 'center' } }}
                                    style={{
                                        fontWeight: 600,
                                        fontSize: 16,
                                        textAlign: 'center'
                                    }}
                                    placeholder='Enter Practice Set Name'
                                    onChange={event => {
                                        setName(event.target.value);
                                    }}
                                />
                            </div>
                            <div className='d-flex flex-column justify-content-center align-items-center mt-4 mb-4 px-4' style={{
                                gap: '6px',
                            }}>
                                <Button
                                    style={{
                                        width: "100%",
                                        fontSize: '14px'
                                    }}

                                    variant='contained' size='small' disabled={loading1 || loading2 || name === "" || !selectedCategories || selectedCategories?.length === 0}
                                    onClick={() => {
                                        onCreatePracticeSet(true)
                                    }}
                                >
                                    {loading1 ? <BeatLoader color={'#bb0000'} loading={true} size={8} /> : `Save`}
                                </Button>
                                <Button
                                    className='mt-2'
                                    style={{
                                        width: "100%",
                                        fontSize: '14px'
                                    }} variant='contained' size='small' disabled={loading1 || loading2 || name === "" || selectedCategories?.length === 0}
                                    onClick={() => {
                                        onCreatePracticeSet(false)
                                    }}
                                >
                                    {loading2 ? <BeatLoader color={'#bb0000'} loading={true} size={8} /> : `Save & Begin Now`}
                                </Button>
                            </div>
                        </div>
                    }
                </Card>
            </Popover>
        </div>

    );
}

export default SFPracticeSetCart;
